export default [
  {
    code: 'FlinksCapital',
    name: 'Flinks Capital',
    usernameLabel: 'Username',
    passwordLabel: 'Password',
  }, {
    code: 'ATB',
    name: 'ATB Financial',
    usernameLabel: 'Username',
    passwordLabel: 'Password',
  }, {
    code: 'BMO',
    name: 'Bank of Montreal',
    usernameLabel: 'Card Number',
    passwordLabel: 'Password',
  }, {
    code: 'CIBC',
    name: 'Canadian Imperial Bank of Commerce',
    usernameLabel: 'Card Number',
    passwordLabel: 'Password',
  }, {
    code: 'CoastCapital',
    name: 'Coast Capital Savings Credit Union',
    usernameLabel: 'Username or Debit Card Number (last 8 digits)',
    passwordLabel: 'Password',
  }, {
    code: 'Desjardins',
    name: 'Desjardins Quebec',
    usernameLabel: 'Card number or user code',
    passwordLabel: 'Password',
  }, {
    code: 'Meridian',
    name: 'Meridian Credit Union',
    usernameLabel: 'Username',
    passwordLabel: 'Password',
  }, {
    code: 'National',
    name: 'National Bank of Canada',
    usernameLabel: 'Email or Client card No. (Last 12 digits)',
    passwordLabel: 'Password',
  }, {
    code: 'Laurentienne',
    name: 'Banque Laurentienne du Canada',
    usernameLabel: 'Access code',
    passwordLabel: 'Password',
  }, {
    code: 'Simplii',
    name: 'Simplii Financial (Former President\'s Choice Financial)',
    usernameLabel: 'Username',
    passwordLabel: 'Password',
  }, {
    code: 'RBC',
    name: 'Royal Bank of Canada',
    usernameLabel: 'Client Card or Username',
    passwordLabel: 'Password',
  }, {
    code: 'Scotia',
    name: 'The Bank of Nova Scotia',
    usernameLabel: 'Username or Card number',
    passwordLabel: 'Password',
  }, {
    code: 'Tangerine',
    name: 'Tangerine Bank',
    usernameLabel: 'Client Number, Card Number or Username',
    passwordLabel: 'Password',
  }, {
    code: 'TD',
    name: 'Toronto-Dominion Bank',
    usernameLabel: 'Username or Access Card',
    passwordLabel: 'Password',
  }, {
    code: 'Vancity',
    name: 'Vancouver City Savings Credit Union',
    usernameLabel: 'MEMBER CARD #',
    passwordLabel: 'PAC',
  }, {
    code: 'HSBC',
    name: 'HSBC Canada',
    usernameLabel: 'Username',
    passwordLabel: 'Password',
  }, {
    code: 'EQBank',
    name: 'Equitable Bank',
    usernameLabel: 'Username',
    passwordLabel: 'Password',
  },
];
